import React from 'react'
import PropTypes from "prop-types"
import { FormGroup, ControlLabel, Modal } from 'react-bootstrap'
import { get } from 'lodash'
import { DateTimePicker } from 'react-widgets'
import moment from "moment"

import { str2date, date2str } from '../../../lib/Tools'
import Button from '../../components/Button.jsx'
import { getText } from '../../lib/text.js'

import { editScheduleDates, checkOverlap, timetablePropType, schedulePropType } from '../timetable'

export default class EditScheduleModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { startDate: props.schedule.startDate, endDate: props.schedule.endDate }
  }

  componentDidUpdate(_prevProps, _prevState) {
    const { startDate, endDate } = this.state
    const { timetable, schedule } = this.props

    if (startDate > endDate) {
      this.setState({ orderError: true })
    }
    else if (
      startDate && endDate && (
        timetable != _prevProps.timetable
        || schedule != _prevProps.schedule
        || startDate != _prevState.startDate
        || endDate != _prevState.endDate
      )
    ) {
      this.setState({ overlapState: checkOverlap(timetable, startDate, endDate, schedule.key) })
    }
    else {
      this.setState({ orderError: false })
    }
  }

  ready() {
    return (this.state.startDate && this.state.endDate && !get(this.state, "overlapState.overlap", false) && !this.state.orderError)
  }

  render() {
    const { timetable, schedule, onClose, onChange } = this.props
    return (
      <Modal show onHide={() => this.props.onClose()} className="edit-schedule-modal">
        <Modal.Header>
          {getText(`Editar horario`)}
        </Modal.Header>
        <Modal.Body>
          <div>
            <FormGroup style={{ marginTop: 10 }}>
              <ControlLabel style={{ marginRight: 5 }}>{getText("De")}:</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                format="LL"
                editFormat="YYYY/MM/DD"
                value={this.state.startDate ? str2date(this.state.startDate) : null}
                onChange={d => this.setState({ startDate: date2str(d) }) }
              />
              <ControlLabel style={{ marginRight: 5, marginLeft: 5 }}>{getText("a")}:</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                format="LL"
                editFormat="YYYY/MM/DD"
                value={this.state.endDate ? str2date(this.state.endDate) : null}
                onChange={d => this.setState({ endDate: date2str(d) })}
              />
            </FormGroup>
            {
              get(this.state, ['overlapState', 'overlap']) && (
                <div className="error">❌ Este horario se solapa con otro existente</div>
              )
            }
            {
              this.state.orderError && (
                <div className="error">❌ Fecha de inicio no puede ser posterior a la de fin</div>
              )
            }
          </div>
          <div className="direct-accesses">
            <label>Ejemplos:</label>
            {
              [
                {
                  label: "Este mes",
                  startDate: moment().startOf("month").format("YYYY/MM/DD"),
                  endDate: moment().endOf("month").format("YYYY/MM/DD"),
                },
                {
                  label: "Mes que viene",
                  startDate: moment().add(1, "month").startOf("month").format("YYYY/MM/DD"),
                  endDate: moment().add(1, "month").endOf("month").format("YYYY/MM/DD"),
                },
                {
                  label: "Todo este año",
                  startDate: moment().startOf("year").format("YYYY/MM/DD"),
                  endDate: moment().endOf("year").format("YYYY/MM/DD"),
                },
                {
                  label: "Este año y el que viene",
                  startDate: moment().startOf("year").format("YYYY/MM/DD"),
                  endDate: moment().add(1, "year").endOf("year").format("YYYY/MM/DD"),
                }
              ].map(({ label, startDate, endDate }) => (
                <Button key={label} bsStyle="link" onClick={() => this.setState({ startDate, endDate })} label={label} />
              ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose()} label={getText("Cancelar")} />
          <Button
            disabled={!this.ready()}
            bsStyle="success"
            label={getText("Guardar")}
            onClick={() => {
              onChange(editScheduleDates(timetable, schedule.key, this.state.startDate, this.state.endDate))
            }}
          />
        </Modal.Footer>
      </Modal>
    )
  }
}

EditScheduleModal.propTypes = {
  timetable: timetablePropType.isRequired,
  schedule: schedulePropType.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
